import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';
import dutchMessages from 'ra-language-dutch';
import russianMessages from 'ra-language-russian';
import armenianMessages from 'ra-language-armenian';
import germanMessages from 'ra-language-german';
import brasilMessages from 'ra-language-pt-br';

// Import custom translations
import enCustom from './i18n/en.json';
import nlCustom from './i18n/nl.json';
import ruCustom from './i18n/ru.json';
import hyCustom from './i18n/hy.json';
import deCustom from './i18n/de.json';
import ptCustom from './i18n/pt.json';

// Merge React Admin base messages with custom translations
const messages = {
    en: { ...englishMessages, ...enCustom },
    nl: { ...dutchMessages, ...nlCustom },
    ru: { ...russianMessages, ...ruCustom },
    hy: { ...armenianMessages, ...hyCustom },
    de: { ...germanMessages, ...deCustom },
    pt: { ...brasilMessages, ...ptCustom }
};

// Create the i18n provider
const i18nProvider = polyglotI18nProvider(
    (locale) => messages[locale] || messages.en,
    'en', // default locale
    { allowMissing: true }
);

export default i18nProvider;
